module.exports = __webpack_public_path__ + "static/img/1.7d995d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = tGse
// module chunks = 1